import userManagement from '../apis/userManagement.api';
import { UserProject } from '../types/project.types';
import { AxiosResponse } from 'axios';
interface QueryParamsProps {
	cursor?: string | null;
	limit?: number | null;
	searchText?: string | null;
	sortBy?: string | null;
	sortOrder?: 'asc' | 'desc' | null;
	sourceId?: string;
}

export const getProjects = (
	queryParams?: QueryParamsProps | null,
): Promise<AxiosResponse<UserProject[]>> => {
	const payload = {
		includeProducts: true,
		pagination: {
			cursor: queryParams?.cursor ?? undefined,
			limit: queryParams?.limit ?? 20,
		},
		...(queryParams?.searchText ||
		queryParams?.sortBy ||
		queryParams?.sourceId
			? {
					filterInput: {
						name: queryParams?.searchText ?? undefined,
						sortProperties: queryParams?.sortBy
							? {
									sortBy: queryParams.sortBy,
									sortOrder: queryParams.sortOrder ?? 'asc',
							  }
							: undefined,
						sourceId: queryParams?.sourceId ?? undefined,
					},
			  }
			: {}),
	};
	return userManagement.post('projects', payload);
};
